export default __webpack_public_path__ + "static/media/mantle_bg345.05894e4b.jpg";